module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [_c('popup', {
    attrs: {
      "button-style": "primary",
      "heading": "New Site Contractor Statement",
      "show-text": _vm.showText,
      "button-text": "Site Cont.",
      "center-button": true,
      "button-size": _vm.buttonSize,
      "disable-button": !_vm.isManager('project|maintenance|management|finance'),
      "button-icon": "fa fa-plus"
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('site-contractors-details', {
    ref: "scd",
    attrs: {
      "row-data": _vm.siteContData,
      "editMode": _vm.editMode,
      "adding": true,
      "hide-panel": "",
      "site-id": _vm.siteId,
      "table-ref": _vm.tableRef
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d977739"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/SiteContractorAction.vue
// module id = 1542
// module chunks = 0